import {fromJS} from 'immutable'
import { get } from '../../util/http'
import debounce from 'lodash/debounce'

/**
 * Actions
 */
export const ATTEMPT_GET_RESULTS = 'expii/search/ATTEMPT_GET_RESULTS'
const ATTEMPT_GET_TRENDING_TOPICS = 'expii/search/ATTEMPT_GET_TRENDING_TOPICS'
const PROCESS_RESULTS = 'expii/search/PROCESS_RESULTS'
export const PROCESS_TRENDING_TOPICS = 'expii/search/PROCESS_TRENDING_TOPICS'
const APPLY_FILTER = 'expii/search/APPLY_FILTER'
const GET_NEXT_PAGE = 'expii/search/GET_NEXT_PAGE'
export const CLEAR_SEARCH = 'expii/search/CLEAR_SEARCH'

/**
 * Reducer
 */
const defaultSearchState = fromJS({
  isFetching: false,
  trendingTopics: [],
  query: '',
  page: 0,
  filters: [],
  esResults: {}
})

export default function reducer(state = defaultSearchState, action = {}) {
  switch (action.type) {
  case ATTEMPT_GET_TRENDING_TOPICS:
    return state.set('isFetching', true)
  case ATTEMPT_GET_RESULTS:
    if (action.query === state.get('query')) {
      return state.merge(
        fromJS({
          query: action.query,
          isFetching: true
        })
      )
    } else {
      return state.merge(
        fromJS({
          query: action.query,
          page: 0,
          isFetching: true
        })
      )
    }
  case PROCESS_RESULTS:
    if (state.get('page') > 0) {
      // handle proper concatenation of results list
      // rather than replacing the old one
      return state.mergeWith(
        (prev, next, key) => {
          if (key === 'esResults') {
            return prev.update('results', value =>
              value.concat(next.get('results'))
            )
          }
          return next
        },
        fromJS({
          esResults: action.payload.results,
          isFetching: false
        })
      )
    } else {
      return state.merge(
        fromJS({
          esResults: action.payload.results,
          isFetching: false
        })
      )
    }
  case PROCESS_TRENDING_TOPICS:
    return state.merge(
      fromJS({
        trendingTopics: action.payload.trending
      })
    )
  case APPLY_FILTER:
    let filters = state.get('filters')
    const indexOfFilter = filters.indexOf(action.filter)
    if (indexOfFilter !== -1) {
      filters = filters.filterNot(x => x === action.filter)
    } else {
      filters = filters.push(action.filter)
    }
    return state.merge(
      fromJS({
        filters: filters,
        page: 0
      })
    )
  case GET_NEXT_PAGE:
    return state.update('page', value => value + 1)
  case CLEAR_SEARCH:
    return defaultSearchState.set(
      'trendingTopics',
      state.get('trendingTopics')
    )
  default:
    return state
  }
}

/**
 * Action Creators
 */
export function attemptGetResults(query) {
  return { type: ATTEMPT_GET_RESULTS, query }
}

export function attemptGetTrendingTopics() {
  return { type: ATTEMPT_GET_TRENDING_TOPICS }
}

export function processTrendingTopics(trending) {
  return { type: PROCESS_TRENDING_TOPICS, payload: trending }
}

export function processResults(results_data) {
  return { type: PROCESS_RESULTS, payload: results_data }
}

export function _applyFilter(filter) {
  return { type: APPLY_FILTER, filter }
}

export function _getNextPage() {
  return { type: GET_NEXT_PAGE }
}

export function clearSearch() {
  return { type: CLEAR_SEARCH }
}

/**
 * Side Effects
 */

export function getTrendingTopics() {
  return (dispatch, getState) => {
    return get('/api/v2/trending_topics').then(json => {
      let { output } = json
      json = {
        trending: output
      }
      dispatch(processTrendingTopics(json))
    })
  }
}

const debouncedSearch = debounce((query, filters, page, callback) => {
  //mixpanel.track('XP_main_search_bar_query', { query: query });
  return get(
    `/api/v2/t?q=${query}&filters=${JSON.stringify(filters)}&page=${page}`
  ).then(json => {
    callback(json)
  })
}, 250)

export function getQueryResults(query) {
  return (dispatch, getState) => {
    dispatch(attemptGetResults(query))
    const results = selectResults(getState())
    const filters = results['activeFilters'].toJS()
    const page = results['page']
    if (!query.length) {
      if (filters.length === 1) {
        query = filters[0]
      }
    }
    return debouncedSearch(query, filters, page, json => {
      let { success, output } = json
      json = {
        success: success,
        query: query,
        results: output
      }
      dispatch(processResults(json))
    })
  }
}

function reGetQueryResults() {
  return (dispatch, getState) => {
    const currResults = selectResults(getState())
    let query = currResults.query
    dispatch(getQueryResults(query))
  }
}

export function applyFilter(filter) {
  return (dispatch, getState) => {
    dispatch(_applyFilter(filter))
    dispatch(reGetQueryResults())
  }
}

export function getNextPage() {
  return (dispatch, getState) => {
    dispatch(_getNextPage())
    dispatch(reGetQueryResults())
  }
}

/**
 * Selectors
 */
export const selectResults = state => {
  const domain = state.get('search')
  const esResults = domain.get('esResults')
  return {
    esResults: esResults,
    activeFilters: domain.get('filters'),
    trendingTopics: domain.get('trendingTopics'),
    page: domain.get('page'),
    query: domain.get('query'),
    isFetching: domain.get('isFetching'),
    didGetResults: !esResults.isEmpty(),
    hasMore: !esResults.isEmpty()
      ? esResults.get('results').size < esResults.get('total')
      : false
  }
}

export const selectActiveFilters = state => {
  const domain = state.get('search')
  return { activeFilters: domain.get('filters') }
}



// WEBPACK FOOTER //
// ./src/redux/modules/search.js